import { QueryResult } from '@apollo/client';

import {
  SearchLicensesQuery,
  SearchLicensesQueryVariables,
} from '../../api/ariadne/__generated_types__/apollo';

import { SearchResult } from './search-results';

export type QueryProjection = Pick<
  QueryResult<SearchLicensesQuery, SearchLicensesQueryVariables>,
  'loading' | 'error' | 'data'
>;

export function queryToResults(query: QueryProjection): SearchResult[] {
  if (query.loading) {
    return [];
  }

  if (query.error) {
    // Alerts are triggered on the server side; we slightly degrade customer experience by not showing license search,
    // but overall search is still available.
    return [];
  }

  if (!query.data) {
    return [];
  }

  return query.data.region.strLicenses.edges
    .map((edge) => edge.node)
    .map((node) => ({
      address: node.address ?? 'Unknown',
      apn: node.apn,
      deckardid: node.propertyDeckardid,
      // While technically optional for A license, we are guaranteed to have the license number as we perform search by
      // it.
      strLicense: node.licenseNumber ?? '',
      listingIds: null,
    }));
}
